export enum Environments {
  DEVELOPMENT = "development",
  STAGING = "staging",
  PRODUCTION = "production",
}

export type EnvironmentNames = `${Environments}`;

const FeatureFlagValues = [
  "enableTerminateCard",
  "enableAdminAuthorization",
] as const;

export type FeatureFlag = typeof FeatureFlagValues[number];

export type FeatureFlagSet = Readonly<Record<FeatureFlag, boolean>>;

export const featureFlags: Readonly<Record<EnvironmentNames, FeatureFlagSet>> =
  {
    development: {
      enableTerminateCard: true,
      enableAdminAuthorization: false,
    },
    staging: {
      enableTerminateCard: true,
      enableAdminAuthorization: false,
    },
    production: {
      enableTerminateCard: true,
      enableAdminAuthorization: false,
    },
  };
